import { PeerExclusionsList } from "@/components/reviews/PeerExclusionsList";
import { ReviewConfigList } from "@/components/reviews/ReviewConfigList";
import { ReviewQuestionsList } from "@/components/reviews/ReviewQuestionsList";

/**
 * Settings → Config → Reviews.
 *
 * The review reference lists, on one page rather than four more tabs on a
 * Config list that is already twelve long — they are only meaningful together,
 * and only while Reviews is switched on, which is when this tab appears.
 *
 * Labelled "Reviews" rather than "Feedback" even though it belongs to the
 * Feedback nav section: Settings already has a Feedback tab, for the
 * bug-and-feature widget, and two tabs with one label on the same screen is
 * the confusion the `review_` prefix exists to avoid.
 *
 * Everything the legacy Feedback app keeps as configuration is configuration
 * here too. See `docs/performance-reviews-legacy-reconciliation.md`.
 */
export function SettingsReviewConfigPage() {
  return (
    <div className="space-y-8">
      <p className="max-w-3xl text-muted-foreground text-sm">
        The lists behind performance reviews. You can rename anything here, change the order it
        appears in, and switch off anything you don't want offered. The ones the app came with can't
        be removed, because the review process itself relies on them.
      </p>

      {/*
        First on the page, because it is the one list people come here to
        change. The four below it are the workflow's own vocabulary and are
        mostly set once.
      */}
      <ReviewQuestionsList />

      <ReviewConfigList
        list="statuses"
        title="Statuses"
        description="The stages a review round, a person's review, and a reviewer's task move through."
        scoped
      />

      <ReviewConfigList
        list="relationships"
        title="Reviewer types"
        description="Who a review form can ask — and who the system works out automatically when a round opens."
      />

      <ReviewConfigList
        list="cycle-types"
        title="Round types"
        description="The kinds of review round you run. “Covers everyone” decides the roster: on, the round pulls everyone eligible in; off, it starts empty and you name who it covers."
      />

      <ReviewConfigList
        list="sentiments"
        title="Feedback types"
        description="How a piece of written feedback is meant — a strength, something to work on, an observation."
      />

      <PeerExclusionsList />
    </div>
  );
}
